import { forwardRef, useState } from 'react';
import classNames from 'classnames';
import { AccordionSection } from '@medifind/containers';
import { Skeleton } from '@medifind/shared-basic-components';
import { ExpandButton } from '@medifind/shared-basic-components';
import { isPrerender } from '@medifind/utils';
import ClinicalTrialLocation from './ClinicalTrialLocation';
import styles from './ClinicalTrialShared.module.scss';
const ClinicalTrialLocations = forwardRef(({ openByScroll, locationsUS, otherLocations, isLoading, contacts, trialName }, ref) => {
  const usLocationsArr = Object.keys(locationsUS).map((state) => locationsUS[state]);
  const [isUSExpanded, setIsUSExpanded] = useState(true);
  const [isOtherLocExpanded, setIsOtherLocExpanded] = useState(usLocationsArr.length === 0 || isPrerender);

  return (
    <AccordionSection
      classes={{
        container: styles['accordian-container'],
        header: styles['accordian-header'],
        title: styles['accordian-title'],
        body: styles['accordian-body'],
      }}
      ref={ref}
      openByScroll={openByScroll}
      expandable
      title="Locations"
      isLoading={isLoading}
    >
      {!isLoading ? (
        <>
          {usLocationsArr.length > 0 && (
            <>
              {/* USLocations*/}
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
              <div
                className={classNames(styles['location-heading-container'], styles['clickable'])}
                onClick={() => setIsUSExpanded(!isUSExpanded)}
                tabIndex={-1}
              >
                <div>United States</div>
                <ExpandButton isExpanded={isUSExpanded} size="medium" title="United States" />
              </div>
              {isUSExpanded ? (
                <div className={styles['locations-container']}>
                  {usLocationsArr.map((state, i) => {
                    return <ClinicalTrialLocation key={`us-${i}`} location={state} contacts={contacts} trialName={trialName} />;
                  })}
                </div>
              ) : null}
            </>
          )}
          {/* Other Locations*/}
          {otherLocations.length > 0 && (
            <>
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
              <div
                className={classNames(styles['location-heading-container'], styles['clickable'])}
                onClick={() => setIsOtherLocExpanded(!isOtherLocExpanded)}
                tabIndex={-1}
              >
                <div>Other Locations</div>
                <ExpandButton isExpanded={isOtherLocExpanded} size="medium" title="Other Locations" />
              </div>
              {isOtherLocExpanded ? (
                <div className={styles['locations-container']}>
                  {otherLocations.map((facility, i) => {
                    return <ClinicalTrialLocation key={`other-${i}`} location={facility} contacts={contacts} trialName={trialName} />;
                  })}
                </div>
              ) : null}
            </>
          )}
        </>
      ) : (
        <Skeleton count={5} />
      )}
    </AccordionSection>
  );
});
ClinicalTrialLocations.displayName = 'ClinicalTrialLocations';
export { ClinicalTrialLocations as default, ClinicalTrialLocations };
